/**
 * 度分秒转经纬度
 * @param dfm
 * @returns {number}
 */
 export function convertGPSToXY(dfm) {
    const arr1 = dfm.split('°');
    const d = arr1[0];
    const arr2 = arr1[1].split("'")
    let f = arr2[0] || 0;
    const m = arr2[1].replace('"', '') || 0;
    f = parseFloat(f) + parseFloat(m / 60);
    var du = parseFloat(f / 60) + parseFloat(d);
    return du.toFixed(4);
}

/**
 * 经纬度转度分秒
 * @param point
 * @returns {*}
 */
export function convertXYToGPS(point) {

    let xy;
    if (point instanceof Array) {
      xy = point;
    } else {
      point = point + "";
      xy = point.split(',');
    }

    let dPoint = [];
    let dPointStr = "";
    for (let i = 0; i < xy.length; i++) {
      const mElement = xy[i] + "";
      const arr1 = mElement.split(".");
      const d = arr1[0];
      let tp = "0." + arr1[1]
      tp = String(tp * 60); //这里进行了强制类型转换
      const arr2 = tp.split(".");
      const f = arr2[0];
      tp = "0." + arr2[1];
      tp = tp * 60;
      const m = tp.toFixed(2);
      const dfm = {
        degree: d,
        minute: f === "NaN" ? 0 : f,
        second: m === "NaN" ? 0 : m
      }
      dPointStr += "," + dfm;
      dPoint.push(dfm);
    }

    dPointStr = dPointStr.replace(',', '');

    return point instanceof Array ? dPoint : dPointStr;
  }
  export function createPointJsonData(coords) {
    return {
      type: "Point",
      coordinates: coords
    }
  }
